import React, { Component } from 'react';
import { DataHandler } from 'C4';

export default class BackVideo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      video: null,
      image: null,
      size: null,
      ready: false,
    };
  }

  componentWillMount() {
    if (window.location.href.includes('/exhibition')) {
      DataHandler.matchAppId()
        .then(appId => this.setState({
          video: 'https://front.travpromobile.com/614/Sizzle%20Updated.mp4',
          image: 'https://cdn.jwplayer.com/thumbs/zT1KnRC7-1920.jpg',
          size: {
            width: document.body.clientWidth,
            height: document.body.clientHeight,
          },
        }));
    } else {
      DataHandler.matchAppId()
        .then(appId => this.setState({
          video: 'https://front.travpromobile.com/614/Sizzle%20Updated.mp4',
          image: 'https://cdn.jwplayer.com/thumbs/zT1KnRC7-1920.jpg',
          size: {
            width: document.body.clientWidth,
            height: document.body.clientHeight,
          },
        }));
    }
  }

  render() {
    const {
      video, image, size, ready,
    } = this.state;
    return (
      <video
        className="backgroundVideo"
        autoPlay
        muted
        playsInline
        loop
        preload="auto"
        poster={image}
        onLoadedData={() => {
          if (!ready) this.setState({ ready: true });
        }}
        style={{ opacity: ready ? 1 : 0 }}
      >
        <source src={video} />
        <track kind="captions" />
      </video>
    );
  }
}
